import { useEffect, useContext, useState } from "react";
import MapContext from "../map/MapContext";
import olMap from "ol/Map";
import ZoomToClusterInteraction, { ZoomToClusterProps } from "./ZoomToClusterInteraction";

const ZoomToCluster = ({ hitTolerance }: ZoomToClusterProps) => {
  const map = useContext(MapContext) as olMap;
  const [interaction, setInteraction] = useState<ZoomToClusterInteraction | null>(null);

  useEffect(() => {
    if (!map) return () => {};

    const interaction = new ZoomToClusterInteraction({
      hitTolerance
    });

    map.addInteraction(interaction);
    setInteraction(interaction);

    return () => {
      if (!map) return;
      map.removeInteraction(interaction);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  useEffect(() => {
    if (!interaction) return;
    interaction.setHitTolerance(hitTolerance);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hitTolerance]);

  return null;
};

export default ZoomToCluster;